import { CreateCallingListComponent } from "@app/sidebar/calling-lists/create-calling-list/create-calling-list.component";
import { CallingListCreateGuard } from "@app/sidebar/guards/calling-list-create-guard.service";

export const sidebarCreateCallingListRoutes = {
  path: "create-calling-list",
  component: CreateCallingListComponent,
  canActivate: [CallingListCreateGuard],
};
